
import nora_img from '../Assets/Images/Expertos/nora.png';
import xochitl_img from '../Assets/Images/Expertos/xochitl.png';
import perla_img from '../Assets/Images/Expertos/perla_copy.png';
import xunani_img from '../Assets/Images/Expertos/xunaxi_copy.png';
import ximena_img from '../Assets/Images/Expertos/ximena_copy.png';
import paola_img from '../Assets/Images/Expertos/paola_alvarado.png';

export const ExpertData = [
    {
        img: paola_img,
        name: 'Paola Azucena Alvarado Pelayo',
        workstation: 'Líder de Gestión en Educación',
        professionalLicense: '13858142',
        team: 'education',
        description: 'Nutrióloga Renal y Educadora en Diabetes. Kidney Health Coach por la American Kidney Fund.  Miembro de la Sociedad Internacional de Nutrición Renal y Metabolismo (ISRNM). Colaboración como autora del libro Nutrición en la enfermedad poliquística renal, manual de inducción para pacientes y familiares de NIN Institute. Investigación y ejecución de protocolos: "Ensayo Clínico sobre nutrición en población renal en etapa de prediálisis". Investigación en el abordaje nutricional enfocado en enfermedades renales. '
    },
    // {
    //     img: paola_img,
    //     name: 'Karen Hernández',
    //     workstation: 'Asesora Clínica en Educación',
    //     professionalLicense: '',
    //     team: 'education',
    //     description: ''
    // },
    {
        img: perla_img,
        name: 'Perla Sonora Hernández Hernández',
        workstation: 'Líder de Innovación y Desarrollo Tecnológico',
        professionalLicense: '12942810',
        team: 'innovation',
        description: 'Nutrióloga, Tecnóloga química en alimentos. Encargada de llevar a cabo el desarrollo e investigación de suplementos alimenticios acorde a las necesidades nutrimentales en diferentes patologías, principalmente enfocados en la enfermedad renal crónica. Apasionada en crear y mejorar productos que contribuyan a las necesidades especiales de los consumidores, cumpliendo con las características nutrimentales y sensoriales, brindando un producto de calidad.'
    },
    {
        img: ximena_img,
        name: 'Ximena Danae Velázquez Reyes',
        workstation: 'Nutrióloga Clínica e Investigación',
        professionalLicense: [],
        team: 'clinical-research',
        description: 'Lic. en Nutrición, Honorable Socio de la comunidad del Colegio Mexicano de Nutrición Clínica y Terapia Nutricional A.C. Certificada por ISAK nivel 1. Diplomado en Nutrición Clínica y Soporte Nutricional  y enfoque a Nutrición Renal. Me gusta interactuar con mis pacientes, conocerlos y adaptarme a sus creencias, cultura y hábitos. Mi trabajo es enseñarles y hacerles ver aquellas cosas que no sabíamos que perjudicaban nuestra salud, y que con un buen estilo de vida y alimentación podemos llegar a mantener un estado de salud óptimo.'
    },
    {
        img: xunani_img,
        name: 'Xunaxi Nahomi Garcia Rodríguez',
        workstation: 'Líder de Soporte e Investigación',
        professionalLicense: '13125434',
        team: 'clinical-research',
        description: 'Nutrióloga clínica enfocada en enfermedad renal (diálisis, Hemodiálisis y ERC) con maestría Internacional en Nutrición y Dietética. Experiencia en embarazo, lactancia y nutrición infantil. Docente a nivel licenciatura, Ponente de cursos de nutrición.  Investigación clínica. Me apasiona la alimentación y nutrición de las personas.'
    },
    {
        img: xochitl_img,
        name: 'Xochitl Berenice Trigueros Flores',
        workstation: 'Gestora de Soporte e Investigación',
        professionalLicense: [],
        team: 'clinical-research',
        description: 'Nutrióloga clínica con enfoque en enfermedad renal y amplia experiencia en investigación clínica especializada en el acompañamiento del paciente. Miembro durante 1 año de la Sociedad Internacional de Nefrología y autora del artículo "Barreras y facilitadores para la adherencia a una dieta saludable en el espectro de la enfermedad renal crónica'
    },
    {
        img: nora_img,
        name: 'Nora Astrid Palafox Navarro',
        workstation: 'Analista de Soporte e Investigación clínica',
        professionalLicense: [],
        team: 'clinical-research',
        description: 'Nutrióloga clínica con experiencia en investigación y nutrición funcional, especializada en el desarrollo de estrategias basadas en evidencia y personalizadas para mejorar la calidad de vida del paciente.'
    }
];